export const Fonts = {
  primary: "gilroy, 'sans-serif'",
  default: "roboto",
}
